import React, { useEffect, useState } from 'react';
import InputFile from '../../components/form/InputFile';
import logo from '../../assets/images/logo.svg';
import errorFace from '../../assets/images/errorFace.svg';
import { useNavigate, useLocation } from "react-router-dom";
import Swal from 'sweetalert2';
import documentChallengeData from '../../types/documentChallenge.type';
import DocumentsService from "../../services/documents.service";
import { pageWard } from '../../utils/pageward';
import NextButton from '../../components/ui/NextButton';
import { sendEvent } from '../../utils/firebase';

function Documents() {
  
  const navigate = useNavigate();
  const state = useLocation();

  useEffect(() => {
    sendEvent("INGRESA_PAGINA_DOCUMENTOS");
  }, []);

  useEffect(() => {
    if (!pageWard("NEED_TO_UPLOAD_DOCUMENTS")) {
      navigate('/')
      return;
    };
  }, []);

  const [customerId] = useState(state.state.customerId);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setLoading] = useState(false);
  
  useEffect(() => {
    setIsActive(true);
    setTimeout(() => {
      setIsHiden(true);
    }, 1000)
  }, []);

  async function nextChallenge( sessionId: string) {
    setLoading(true);
    setIsDisabled(true);
    const docData: documentChallengeData = {
      challengeName: "NEED_TO_UPLOAD_DOCUMENTS",
      termOfServiceRespond: "wally_1-0-0",
      sessionId: sessionId,
      securityProfileId: "P1-Web",
      enrollmentCustomer:{
        firstName: "",
      }
    }
    DocumentsService.nextChallenge(docData)
    .then((response: any) => {
      setLoading(false);
      setIsDisabled(false);
      if (response.data) {
        sendEvent("DOCUMENTOS_VALIDADOS");
        DocumentsService.generateToken();
        localStorage.setItem('page', response.data.challengeName);
        navigate("/datos-adicionales",{
          state: {
            name: response.data.enrollmentCustomer.firstName,
            sessionId: response.data.sessionId,
          }
        });
      }
    })
    .catch((e: any) => {
      setLoading(false);
      setIsDisabled(false);
      Swal.fire({
        title: '¡Ooops!',
        text:e.response.data.message,
        imageUrl: errorFace,
        imageWidth: 150,
        imageHeight: 150,
        imageAlt: 'Custom image',
      }).then((result) => {
        if (result.isConfirmed || result.isDismissed) {
            navigate('/');
        }
      })
    });
  }

const [isActive, setIsActive] = useState(false);
const [hideTransition, setIsHiden] = useState(false);


const saveDocuments = () => {
    if (
      (localStorage.getItem("FRONT_DOC")=== "VALID" && localStorage.getItem("REAR_DOC")=== "VALID") ||
      (localStorage.getItem("FRONT_DOC")=== "VALID" && localStorage.getItem("REAR_DOC_TRIES")=== "3") ||
      (localStorage.getItem("REAR_DOC")=== "VALID" && localStorage.getItem("FRONT_DOC_TRIES")=== "3") ||
      (localStorage.getItem("FRONT_DOC_TRIES")=== "3" && localStorage.getItem("REAR_DOC_TRIES")=== "3")
      ) {
      nextChallenge(state.state.sessionId);
      return;
    }
    Swal.fire({
      title: '¡Ooops!',
      text:"Debe subir ambas fotos de su documento.",
      imageUrl: errorFace,
      imageWidth: 150,
      imageHeight: 150,
      imageAlt: 'Custom image',
    })
  }

  return (
    <div className="dark:bg-bgDark h-full p-3 flex flex-col h-screen justify-between">
      
      <header className="w-full p-10">
        <img src={logo} className="h-12 mx-auto" alt="Wally" />
      </header>
      <div className={hideTransition ? 'transitionContainer hide' : 'transitionContainer'}>
        <div className={isActive ? 'transition show' : 'transition'}>
          <div className="layer one"></div>
          <div className="layer two"></div>
          <div className="layer three"></div>
        </div>
      </div>
      <div className="container mb-auto  max-w-md mx-auto ">
        <div className={hideTransition ? 'w-full mx-auto show' : 'w-full mx-auto'}>
          <h1 className="text-2xl text-wallyGray font-semibold dark:text-white">Cargá tu documento de
            identidad</h1>
          <p className="text-gray-400 mt-2">Para validar tu identidad sacale una foto o seleccioná de tus archivos el frente y dorso de tu documento de identidad</p>
          <form action="">
            <div className="relative mt-6">
              <InputFile
                type="FRONT_DOC"
                label="Frente del documento"
                customerId={customerId}
              />
            </div>
            <div className="relative mt-6">
              <InputFile
                type="REAR_DOC"
                label="Dorso del documento"
                customerId={customerId}
              />
            </div>
          </form>
        </div>
      </div>
      <div className="container mb-20  max-w-md mx-auto ">
        <div className="relative text-center w-full">
          <NextButton
                name="CONTINUAR"
                onClick={saveDocuments}
                isDisabled={isDisabled}
                loading ={isLoading}
              />
        </div>
      </div>
    </div>
  );
}

export default Documents;
